import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export default function RedirectToWhatsApp() {
  const { number } = useParams();
  const message = 'Hi, I would like to inquire more about Nivaan.';
  useEffect(() => {
    window.location.href = `https://wa.me/${number}?text=${message}`;
  }, []);
  return (
    <div className='min-h-screen flex items-center justify-center p-4'>
      <div className=' p-8 rounded-lg text-center'>
        <h1 className='text-3xl font-bold text-gray-800 mb-4'>Redirecting...</h1>
        <p className='text-gray-600'>
          You should be redirected to Whats App shortly.
          <br />
          If not, please click{' '}
          <a href={`https://wa.me/${number}?text=${message}`} className='text-blue-600 hover:underline'>
            here
          </a>
          .
        </p>
      </div>
    </div>
  );
}
